module.exports = __webpack_public_path__ + "img/qr-code.91c19c1e.jpg";